import styled from 'styled-components'

export const Root = styled.div`
  padding: 10px 0 0;
  width: 100%;
`
